<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PV2u1E/image/cover.jpg?1731429775476" alt="This image is the cover for the book Way of Fire and Ice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Way of Fire and Ice
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A Radical New Take On Norse Paganism</b></p><p><i>The Way of Fire and Ice</i> reimagines Norse Paganism with mystical practices and rituals for today's world as well as tips for building community and resisting fascism. This approach to working with Norse deities and beliefs is a living, adaptable tradition, representing a strong alternative to the reconstructionist perspectives of Asatru and Heathenry.</p><p>In these pages, the old ways come alive in a radically inclusive form. You will explore the secrets of the World Tree and the mysteries of the gods, work with the many spirits around us, and feel the deep rhythms that drive all life while creating new songs of power. You will also discover how to make these practices part of your every waking moment, developing your own personal spirituality and building healthy, sustainable communities along the way.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ryan Smith
      </h2>
      
      <p class="authorDescription body article"><P><B>Ryan Smith</B> has been a practicing Pagan since his teens with over fifteen years of experience in inclusive and anti-racist Heathen spirituality. He is the author of <I>The Way of Fire and Ice</I> and <I>Spinning Wyrd</I>. In addition to contributing to the anthologies <I>Bringing Race to the Table</I> and <I>¡No Pasarán!:Antifascist Dispatches from a World in Crisis</I>, Ryan has been published at Huginn's Heathen Hof, Patheos Pagan, and Truthout. He has presented talks and rituals at Pantheacon, the Gathering Paths presented by Between the Veils, Hexenfest, and Many Gods West. He regularly writes at onblackwings.com and produces a Heathen podcast, <I>The Wayward Wanderer</I>. He also has a PhD in modern economic and social history and can be found online at Facebook, Mastodon, and Instagram.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26cd9bf0